let mainAtcText = document.querySelector('#productMainSubmit span');
let mainPrice = document.querySelector('.price__regular .price-item--regular');
let fakeCheckboxes = document.querySelectorAll('.pack-fake-checkbox');
document.querySelectorAll('.pack-wrapper .pack').forEach(pack => {
    pack.addEventListener('click', function () {
      resetSelectedPack()
      pack.classList.add('pack-selected');
      pack.querySelector('.pack-fake-checkbox').classList.add('pack-fake-checkbox-checked');
      document.querySelector('input[name=quantity].quantity__input').value = pack.dataset.quantity
      updatePricesWhenPack(pack);
    })
  })


  function updatePricesWhenPack(pack){
    if(document.querySelector('.pack-wrapper') != null){
      mainAtcText.innerHTML = `LÆG I KURV | ${pack.dataset.priceToShow != undefined ? pack.dataset.priceToShow : pack.dataset.price} <s>${pack.dataset.priceToShow != undefined ? pack.dataset.price : ""}</s>`;
      mainPrice.innerHTML = `${pack.dataset.priceToShow != undefined ? pack.dataset.priceToShow : pack.dataset.price} <s>${pack.dataset.priceToShow != undefined ? pack.dataset.price : ""}</s>`;
    }
  }
  
  function resetSelectedPack() {
    document.querySelectorAll('.pack-wrapper .pack').forEach(pack => {
      pack.classList.remove('pack-selected');
      fakeCheckboxes.forEach(fakeCheckbox => {
        fakeCheckbox.classList.remove('pack-fake-checkbox-checked');
      });
    })
  }
  updatePricesWhenPack(document.querySelector('.pack-selected'));